import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTotalActiveClients = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5553 19.0025V17.9359C14.5553 16.4424 14.5553 15.6957 14.2646 15.1252C14.009 14.6235 13.601 14.2155 13.0993 13.9598C12.5288 13.6692 11.7821 13.6692 10.2886 13.6692H6.37751C4.88403 13.6692 4.1373 13.6692 3.56687 13.9598C3.0651 14.2155 2.65715 14.6235 2.40149 15.1252C2.11084 15.6957 2.11084 16.4424 2.11084 17.9359V19.0025M14.5553 5.6692L16.3331 7.44697L19.8886 3.89142M11.4442 7.00253C11.4442 8.72075 10.0513 10.1136 8.33306 10.1136C6.61484 10.1136 5.22195 8.72075 5.22195 7.00253C5.22195 5.28431 6.61484 3.89142 8.33306 3.89142C10.0513 3.89142 11.4442 5.28431 11.4442 7.00253Z",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTotalActiveClients;
